import axios, { AxiosError } from 'axios'
import { handleHttpError, handleHttpResponse } from '../../shared/http'
import { IConfirmCodeResponse } from './auth.types'
import config from '../../shared/config'
import { HTTPResponse } from '../../shared/http/http.types'
import userApi from './user.api'
import { IAuthState } from './auth.atom'

type Contact = { email: string } | { phone: string }

/** Send confirmation code to specified contact */
const submitContact = async (contact: Contact): Promise<HTTPResponse> => {
  return axios
    .post(config.API_URL + '/api/auth/login/', contact)
    .then(handleHttpResponse)
    .catch(handleHttpError)
}

/** Login with confirmation code */
const confirmContact = async (contact: Contact, code: string): Promise<HTTPResponse<IConfirmCodeResponse>> => {
  return axios
    .post(config.API_URL + '/api/auth/confirm/', { ...contact, otp: code })
    .then(handleHttpResponse)
    .catch((err: AxiosError) => {
      if (err.response.status === 401) {
        return { status: 'error' as const, message: 'Код не подходит.\nПроверьте его внимательно и введите еще раз.' }
      }

      return handleHttpError(err)
    })
}

/** Login with the confirmation code and get the user info */
const confirmContactWithInitDataInit = async (contact: Contact, code: string) => {
  const confirmResp = await confirmContact(contact, code)
  if (confirmResp.status === 'error') return confirmResp

  const tokens = confirmResp.body
  const user = await userApi.getSelfInfo(tokens.access)

  return { status: 'success' as const, body: { user, tokens } }
}

const refreshToken = async (refresh: string): Promise<Pick<IAuthState, 'accessToken' | 'accessExpires'>> => {
  const resp = await axios.post(config.API_URL + '/api/auth/refresh/', { refresh }).then((r) => r.data)
  const { access, accessExpires } = resp

  return { accessToken: access, accessExpires: accessExpires * 1000 }
}

const authApi = { submitContact, confirmContactWithInitDataInit, refreshToken }
export default authApi
